import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall

const GetContactUS = (props) => {
  const [
    get_contactus_error,
    get_contactus_loading,
    get_contactus_data,
    get_contactus_function,
  ] = useRequest({
    method: "get",
    url: "/get_contactus",
  });
  console.log(get_contactus_data);
  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_contactus_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام</th>
                <th className="table--title">تلفن همراه</th>
                <th className="table--title">ایمیل</th>
                <th className="table--title">متن</th>
                <th className="table--title">پاسخ</th>
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_contactus_data.data.map((item) => (
                <tr>
                  <td>{item.name}</td>
                  <td>{item.phone_number}</td>
                  <td>{item.email}</td>
                  <td>
                    {item.text ? item.text.slice(0, 30) + " و... " : null}
                  </td>
                  <td>{item.response ? "پاسخ داده شده" : "پاسخ داده نشد"}</td>
                  <td>
                    <Link to={"/dashboard/contactusDetails/" + item._id}>
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        جزییات
                      </button>
                    </Link>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetContactUS };
